import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserInvitationAppResource from "./UserInvitationAppResource";

export const ISSUE_TYPE = 'issue';
export const PROGRESS_TYPE = 'progress';

class UserInvitationEventAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'user-invitation-event';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'users/invitations/events';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'event',
            'userInvitationUuid',
            'userInvitation',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            userInvitation: UserInvitationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            userInvitation: 'user_invitation_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            type: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            event: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            userInvitationUuid: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default UserInvitationEventAppResource;
